// TODO this should eventually be removed as we cannot know all used names of everything in the UI.
export function generateName (
  baseName: string,
  names: string[],
  separator: string = '-',
  useBrackets: boolean = false,
): string {
  if (!names.includes(baseName)) return baseName

  const regex = new RegExp(`(.+?)(?:(${separator}\\d+)|$)`)
  const match = baseName.match(regex)
  const prefix = match ? match[1] ?? '' : baseName
  let index = 1
  let name = ''

  do {
    name = index === 1 ? prefix : `${prefix}${separator}${useBrackets ? `(${index})` : index}`
    ++index
  } while (names.includes(name))

  return name
}

export function getMaxSuffix (prefix: string, names: string[]): number | undefined {
  const suffixes = names.filter(x => x.startsWith(prefix)).map(x => x.slice(prefix.length).trim())
  if (!suffixes.length) return undefined
  const matches = suffixes.map(s => s.match(/^[(-]?(\d+)[)]?$/)?.[1]).map(x => Number(x)).filter(Boolean)
  // Direct match but without a suffix
  if (suffixes.includes('') && matches.length === 0) return 0
  return matches.length ? Math.max(...matches) : undefined
}

export function pluralize (name: string): string {
  const esEndings = ['s', 'sh', 'ch', 'x', 'z']
  const vowels = ['a', 'e', 'i', 'o', 'u']

  switch (true) {
    // -es -> no change
    case name.endsWith('es'): return name
    // -[one of esEndings] -> -es
    case esEndings.some(ending => name.endsWith(ending)): return `${name}es`
    // -[not vowel]y -> -ies
    case name.endsWith('y') && !vowels.includes((name[name.length - 2] ?? '').toLowerCase()):
      return `${name.substring(0, name.length - 1)}ies`
    // -s otherwise
    default: return `${name}s`
  }
}
